<script setup>

</script>

<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.75 3.50008H2.91667M2.91667 3.50008H12.25M2.91667 3.50008L2.91667
      11.6667C2.91667 11.9762 3.03958 12.2729 3.25838 12.4917C3.47717 12.7105
      3.77391 12.8334 4.08333 12.8334H9.91667C10.2261 12.8334 10.5228 12.7105
      10.7416 12.4917C10.9604 12.2729 11.0833 11.9762 11.0833 11.6667V3.50008M4.66667
      3.50008V2.33341C4.66667 2.024 4.78958 1.72725 5.00838 1.50846C5.22717 1.28966
      5.52391 1.16675 5.83333 1.16675H8.16667C8.47609 1.16675 8.77283 1.28966
      8.99162 1.50846C9.21042 1.72725 9.33333 2.024 9.33333 2.33341V3.50008M5.83333
      6.41675V9.91675M8.16667 6.41675V9.91675"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped lang="scss">

</style>